import { render, staticRenderFns } from "./DescriptionModal.vue?vue&type=template&id=7156a7d3"
import script from "./DescriptionModal.vue?vue&type=script&lang=ts"
export * from "./DescriptionModal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports